import React from "react";
import { AuthData } from "../auth/AuthWrapper";
import { Link } from "react-router-dom";

export default function PendingApproval() {
  const { user } = AuthData();
  return (
    <div className="min-h-[60vh] flex items-center justify-center p-6">
      <div className="max-w-xl w-full bg-white shadow rounded p-6">
        <h1 className="text-xl font-semibold mb-2">
          Хандалтын зөвшөөрөл хүлээгдэж байна
        </h1>
        <p className="text-gray-700 mb-4">
          Таны эрх одоогоор идэвхжээгүй байна. Админ баталгаажуулсны дараа та
          системийн мэдээлэл рүү нэвтрэх боломжтой болно.
        </p>
        {user?.isAuthenticated ? (
          <div className="space-y-3">
            <div className="text-sm text-gray-600">
              Та нэвтэрсэн байна. Эрх олгосны дараа хуудас автоматаар нээгдэнэ.
            </div>
            <div className="flex gap-2">
              <button
                className="px-4 py-2 bg-blue-600 text-white rounded"
                onClick={() => window.location.reload()}
                aria-label="Дахин ачаалах"
              >
                Дахин ачаалах
              </button>
              <Link
                to="/"
                className="px-4 py-2 border rounded text-gray-700"
                aria-label="Нэвтрэх хуудас руу очих"
              >
                Нэвтрэх хуудас
              </Link>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}
